<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg></span>
            <span>Bytt passord</span>
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <div class="cell medium-12 large-12">
              <label for="PassordCurrent">Ditt nåværende passord *</label>
              <div class="input-container" :class="{ 'form-error': errors.has('PassordCurrent') }">
                <input type="password" v-model="pass.PassordCurrent" id="PassordCurrent" name="PassordCurrent" v-validate="'required'" required :class="{ 'error': errors.has('PassordCurrent') }">
                <span class="form-error-label" v-if="errors.has('PassordCurrent')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('PassordCurrent')}}
                </span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x">
            <div class="cell medium-6 large-6">
              <label for="Password">Nytt passord</label>
              <div class="input-container" :class="{ 'form-error': errors.has('Passord') }">
                <input type="password" v-model="pass.Passord" id="Passord" name="Passord"  v-validate="'required|min:5|password-secure'" required ref="Passord" :class="{ 'error': errors.has('Passord') }">
                <span class="form-error-label" v-if="errors.has('Passord')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('Passord')}}
                </span>
              </div>
            </div>

            <div class="cell medium-6 large-6">
              <label for="PassordRepeat">Nytt passord igjen</label>
              <div class="input-container" :class="{ 'form-error': errors.has('PassordRepeat') }">
                <input type="password" v-model="pass.PassordRepeat" id="PassordRepeat" name="PassordRepeat" v-validate="'required|confirmed:Passord'" required data-vv-as="Passord" :class="{ 'error': errors.has('PassordRepeat') }">
                <span class="form-error-label" v-if="errors.has('PassordRepeat')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('PassordRepeat')}}
                </span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading" >Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large disabled" >Lagre</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthService from '@/services/AuthService'

export default {
  name: 'UserProfileModal',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      user: {},
      pass: {
        Passord: '',
        PassordRepeat: '',
        PassordCurrent: ''
      }
    }
  },
  created () {
    // Add the kunde email unique rule to our validator
    this.$validator.extend('password-secure', {
      validate: this.$helpers.passwordStrongnessRule,
      getMessage: (field, params, data) => data ? data.message : 'Passordet er ikke sikkert nok'
    })

    this.setFormLoading(false)

    this.user = this.getUser
  },
  methods: {
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      console.log('Submit form')
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Got errors - do no API request
            this.setFormProcessing(false)
            console.log('Validation failure')
          } else {
            // No errors, so try to save
            this.setFormProcessing(true)

            AuthService.changePassword(this.pass)
              .then((response) => {
                console.log(response)
                console.log('Show password changed notification')

                this.$helpers.showSuccessAlert('Passord har blitt endret.')
                this.$emit('close')

                this.pass = { Passord: '', PassordRepeat: '', PassordCurrent: '' }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  // Alert about error
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    isSubmittable: function () {
      return !(this.processing || this.errors.any())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/UserProfileModal.vue